import React from "react";
import ExecutionPreview from "../features/execution/ExecutionPreview";
import DemandPageHeader from "../components/DemandPageHeader";
import DemandSelector from "../components/DemandSelector";
import { useDemandId } from "../context/DemandContext";

export default function ExecutionPage() {
  // Was: useParams() (empty under Dashboard.js) falling back to "DEM-001", which
  // meant the handoff screen could have created ServiceNow objects for the wrong demand.
  const { demandId, setDemandId } = useDemandId();

  return (
    <div>
      <DemandPageHeader
        title="Execution Handoff"
        description="Create the project and condition tasks in ServiceNow"
        breadcrumbPath="Execution Handoff"
      >
        <DemandSelector currentDemandId={demandId} stage="execution" onDemandChange={setDemandId} />
      </DemandPageHeader>
      {demandId ? (
        <ExecutionPreview demandId={demandId} />
      ) : (
        <div style={{ padding: 40, textAlign: "center", color: "var(--cares-text-label)" }}>
          Select a demand to preview its execution handoff.
        </div>
      )}
    </div>
  );
}
